/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Loader component
 * @author Dustin Gage
 */

import React, { memo } from "react";

export const Loader = memo(() => {
	return <div></div>;
});
